import { loadingAsyncState } from 'widgets-for-react'
import { canSafelyCast, TypeCastingValidator } from '../../../utils/safe-type-casting'
import { SponsorData } from './sponsorState'

export const sponsorDataValidator: TypeCastingValidator<SponsorData> = {
  kind: 'object',
  fieldsValidator: {
    Brand: { kind: 'string' },
    UrlField: {
      kind: 'object',
      fieldsValidator: {
        Title: { kind: 'string' },
        Url: { kind: 'string' },
      },
    },
    UrlLink: {
      kind: 'object',
      fieldsValidator: {
        Title: { kind: 'string' },
        Url: { kind: 'string' },
      },
    },
    EnglishBrandPageUrl: {
      kind: 'object',
      fieldsValidator: {
        Title: { kind: 'string' },
        Url: { kind: 'string' },
      },
    },
  },
}

export const loadSponsorData = (apicall: () => Promise<any>) =>
  loadingAsyncState(() =>
    apicall().then((raw) => {
      const maybesponsorData = canSafelyCast<SponsorData>(
        sponsorDataValidator,
        replaceWithEnglishBrandUrl(raw)
      )
      
      return maybesponsorData.kind == 'r'
        ? {
            kind: 'result',
            value: maybesponsorData.v,
            status: 200,
          }
        : {
            kind: 'failed',
            status: 404,
          }
    })
  )

export const replaceWithEnglishBrandUrl = (sponsor: any): SponsorData => {
  if(sponsor.EnglishBrandPageUrl && sponsor.EnglishBrandPageUrl.Title && sponsor.EnglishBrandPageUrl.Url) {
    return sponsor
  }

  return { ...sponsor, EnglishBrandPageUrl: { Title: '', Url: '' } }
}
